
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OnboardingFinished extends Vue {
  @Prop({ type: String, required: true, default: () => '' })
  MFAType!: string;

  disableMFAPopup() {
    this.$store.dispatch('auth/disableMFAOnboarding');
  }
}
